import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../services/login.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  user: FormGroup;
  messageError: string;
  recordarme: boolean;
  spinner: boolean;
  storageEmail: string;
  fieldTextType: boolean;

  constructor(
    private fb: FormBuilder,
    private authService: LoginService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('colaborador');
  }

  ngOnInit(): void {
    const email = window.localStorage.getItem('email');
    if (email) {
      this.storageEmail = window.localStorage.getItem('email');
      this.recordarme = true;
    } else {
      this.recordarme = false;
    }
    this.crearFormulario();
  }

  get correoNoValido(): any {
    return this.user.get('email').invalid && this.user.get('email').touched;
  }

  get pass1NoValido(): any {
    return (
      this.user.get('password').invalid && this.user.get('password').touched
    );
  }

  crearFormulario(): any {
    this.user = this.fb.group({
      email: [
        this.storageEmail ? this.storageEmail : '',
        [Validators.required, Validators.email],
      ],
      password: ['', [Validators.required, Validators.minLength(6)]],
      recordarme: [this.recordarme],
    });
  }

  guardar(): any {
    this.recordarme = this.user.value.recordarme;
    this.spinner = true;
    if (this.user.invalid) {
      return Object.values(this.user.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((ctrl) =>
            ctrl.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }

    this.authService
      .login(this.user.value.email, this.user.value.password)
      .subscribe(
        (resp) => {
          console.log(resp);
          if (resp.token) {
            sessionStorage.setItem('token', resp.token);
            sessionStorage.setItem('email', this.user.get('email').value);
            switch (resp.rol) {
              case 'GRUPO':
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem('name', resp.name);
                const apellidosList: string[] = [];
                const nifColaboradoresList: string[] = [];
                const codigoColaboradoresList: string[] = [];
                for (const colaborador of resp.colaboradores) {
                  apellidosList.push(colaborador.apellido1);
                  nifColaboradoresList.push(colaborador.nif);
                  codigoColaboradoresList.push(colaborador.codigo);
                }
                console.log(apellidosList);
                console.log(nifColaboradoresList);
                console.log(codigoColaboradoresList);
                sessionStorage.setItem(
                  'colaboradores',
                  JSON.stringify(apellidosList)
                );
                sessionStorage.setItem(
                  'nifColaboradores',
                  JSON.stringify(nifColaboradoresList)
                );
                sessionStorage.setItem(
                  'codigoColaboradores',
                  JSON.stringify(codigoColaboradoresList)
                );
                break;
              default:
                sessionStorage.setItem('nifColaborador', resp.colaborador.nif);
                sessionStorage.setItem(
                  'codigoColaborador',
                  resp.colaborador.codigo
                );
                sessionStorage.setItem('rol', resp.rol);
                sessionStorage.setItem(
                  'colaborador',
                  resp.colaborador.apellido1
                );
                break;
            }
            if (resp.rol === 'ROLE_SUPERADMIN') {
              this.router.navigateByUrl('/page/gestion', { replaceUrl: true });
            } else {
              this.router.navigateByUrl('/page/home', { replaceUrl: true });
            }

            if (this.recordarme) {
              window.localStorage.setItem(
                'email',
                this.user.get('email').value
              );
            } else {
              window.localStorage.clear();
            }
          }
        },
        (err) => {
          console.log(err);
          this.spinner = false;
          if (err.status !== 423) {
            Swal.fire(
              'LOGIN INCORRECTO',
              'Introduce un usuario/contraseña válido',
              'warning'
            );
          } else {
            sessionStorage.setItem('email', this.user.get('email').value);
            sessionStorage.setItem('token', err.error.token);
            //this.router.navigateByUrl('/public/password', { replaceUrl: true });
          }
        }
      );
  }

  onForgotPassword(): any {
    this.router.navigate(['forgot'], { relativeTo: this.route.parent });
  }

  toggleFieldTextType(): any {
    this.fieldTextType = !this.fieldTextType;
  }
}
